import { render, staticRenderFns } from "./sideMenu.vue?vue&type=template&id=d056da0c&scoped=true&"
import script from "./sideMenu.vue?vue&type=script&lang=js&"
export * from "./sideMenu.vue?vue&type=script&lang=js&"
import style0 from "./sideMenu.vue?vue&type=style&index=0&id=d056da0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d056da0c",
  null
  
)

export default component.exports